import { /* makeStyles, Theme, */ Typography } from "@material-ui/core";
import React from "react";
import navigationImage from "./Assets/navigation.svg";
import payImage from "./Assets/pay.svg";
import videoImage from "./Assets/video.svg";
import talentImage from "./Assets/talent.svg";
import Categories from "./Categories";
import CategoryData from "./CategoryData";
import ContactInformation from "./WDContactInformation";

// const useStyles = makeStyles((theme: Theme) => ({}));

const categories = [
  {
    title: "Getting Started",
    icon: navigationImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [],
        jobAids: [
          {
            title: "Freeze and Unfreeze Position",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/5cd64b10-29b8-414c-b8bb-635a62c7db9f",
          },
          {
            title: "Labor Distribution Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/302a61f5-a8a7-4cac-91cc-0eada8d4ebcc",
          },
          {
            title: "Close Position",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/5f4430c1-1eea-4bcf-853c-c3948b01fd21",
          },
          {
            title: "Approve Above the Range Offer or Offer at/or Over 20%",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/b53fe8fc-4b1f-4fdb-95f6-eb2499f0ec3d",
          },
          {
            title: "Change Job Approval",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/bc3b3502-e01d-40f7-8505-1430f07bb066",
          },
        ],
      },
    ],
  },
] as CategoryData[];

export default function FinanceLinks() {
  // const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h4">Quick Links for Finance</Typography>

      <br />
      <Categories data={categories} />
      <br />

      <ContactInformation />
    </React.Fragment>
  );
}
